import {
  ChargerSocketConnectionStatusDto,
  ConnectorListItemResponse,
} from '../../../core/cms-api/models';
import { ChargerConnectorStatusNotificaiton } from '../../chargers/models/charger-connector-status.notification';

export class ConnectorUtils {
  static updateStatuses(
    original: ConnectorListItemResponse[],
    statusData: ChargerConnectorStatusNotificaiton[]
  ): ConnectorListItemResponse[] {
    const statusMap = new Map<string, ChargerSocketConnectionStatusDto>();
    const connectorStatusMap = new Map<string, string>();
    for (const notification of statusData) {
      if (notification.connectorId < 1) {
        statusMap.set(
          notification.chargerId,
          this.MapToChargerSocketConnectionStatusDto(
            notification.chargerConnectionStatus
          )
        );
      } else {
        connectorStatusMap.set(`${notification.chargerId}-${notification.connectorId}`, notification.status);
      }
    }
    const res = original.map((item) => {
      const updatedItem = { ...item };
      if (statusMap.has(item.chargerId!)) {
        updatedItem.lastSocketConnectionState = statusMap.get(item.chargerId!);
      }

      if (connectorStatusMap.has(`${item.chargerId}-${item.connectorId}`)) {
        updatedItem.connectorStatus = connectorStatusMap.get(`${item.chargerId}-${item.connectorId}`);
      }
      return updatedItem!;
    });

    return res;
  }

  private static MapToChargerSocketConnectionStatusDto(
    val: number
  ): ChargerSocketConnectionStatusDto {
    switch (val) {
      case 1:
        return ChargerSocketConnectionStatusDto.Connected;
      case 2:
        return ChargerSocketConnectionStatusDto.Disconnected;
      default:
        return ChargerSocketConnectionStatusDto.Unknown;
    }
  }
}
